import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { Reveal } from "./Reveal";
import { CognitiveLinkCard } from "./CognitiveLinkCard";
import { COGNITIVE_LINKS } from "../data/mock";
import { useI18n } from "../i18n/LanguageContext";

export const ResultsPreview = () => {
  const { t } = useI18n();
  const s = t("preview.sample");
  const sampleLink = {
    id: "cl-01",
    title: s.title,
    summary: s.summary,
    concepts: s.concepts,
    reliability: 98,
    source: "arxiv.org / 1706.03762",
    graph: COGNITIVE_LINKS[0].graph,
  };

  return (
    <section id="results-preview" className="relative py-28 md:py-36 px-6">
      <div className="max-w-6xl mx-auto">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-6">
          <Reveal>
            <div>
              <p className="font-mono text-[13px] tracking-[0.3em] uppercase text-[#4BE3FF] mb-5">
                {t("preview.kicker")}
              </p>
              <h2 className="font-display font-bold tracking-tight text-4xl md:text-5xl lg:text-6xl max-w-2xl leading-[1.02]">
                {t("preview.titleA")}
                <span className="text-[#A7B4C2]">{t("preview.titleB")}</span>
              </h2>
            </div>
          </Reveal>
          <Reveal delay={0.1}>
            <Link
              to={`/results?q=${encodeURIComponent("How do transformer models achieve contextual understanding?")}`}
              data-testid="view-full-results"
              className="group inline-flex items-center gap-2 rounded-full border border-[#4BE3FF]/40 hover:bg-[#4BE3FF] hover:text-[#0A1A2F] text-[#4BE3FF] font-mono text-sm px-5 py-3 transition-colors duration-300 whitespace-nowrap"
            >
              {t("preview.cta")}
              <ArrowRight className="w-4 h-4 transition-transform duration-300 group-hover:translate-x-1" />
            </Link>
          </Reveal>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-12 gap-6 mt-14">
          <Reveal className="lg:col-span-4">
            <div className="h-full rounded-2xl border border-[#A7B4C2]/15 bg-[#1E6FFF]/[0.06] p-7">
              <p className="font-mono text-[11px] uppercase tracking-widest text-[#A7B4C2]/60">
                {t("preview.recognizedIntent")}
              </p>
              <p className="font-display text-2xl text-white mt-2">
                {s.intentLabel}
              </p>
              <div className="mt-3 flex items-center gap-2">
                <span className="font-mono text-[12px] text-[#4BE3FF]">
                  {t("preview.confidence")} 94%
                </span>
              </div>
              <div className="h-px w-full bg-white/10 my-6" />
              <p className="font-mono text-[11px] uppercase tracking-widest text-[#A7B4C2]/60 mb-3">
                {t("preview.entities")}
              </p>
              <div className="flex flex-wrap gap-2">
                {s.entities.map((e) => (
                  <span
                    key={e}
                    className="font-mono text-[11px] text-white border border-white/15 rounded-full px-2.5 py-1"
                  >
                    {e}
                  </span>
                ))}
              </div>
            </div>
          </Reveal>

          <div className="lg:col-span-8">
            <CognitiveLinkCard link={sampleLink} />
          </div>
        </div>
      </div>
    </section>
  );
};
